import { render, staticRenderFns } from "./qqCallback.vue?vue&type=template&id=f60fce36&"
import script from "./qqCallback.vue?vue&type=script&lang=js&"
export * from "./qqCallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data-jenkins/jenkins/workspace/html-cube-webapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f60fce36')) {
      api.createRecord('f60fce36', component.options)
    } else {
      api.reload('f60fce36', component.options)
    }
    module.hot.accept("./qqCallback.vue?vue&type=template&id=f60fce36&", function () {
      api.rerender('f60fce36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/callback/qqCallback.vue"
export default component.exports